import { useState } from 'react'
import { Link } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { useAuthStore } from '../lib/auth'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const forgotPassword = useAuthStore((s) => s.forgotPassword)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      await forgotPassword(email)
      setSubmitted(true)
      setLoading(false)
    } catch (err) {
      // Don't reveal if email exists (mirrors Alpha1 security pattern)
      setSubmitted(true)
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-[#0a0e17] text-white">
      <Header />
      <div className="flex items-center justify-center px-4 py-12">
      <div className="card max-w-md w-full">
        {!submitted ? (
          <>
            <h2 className="text-3xl font-bold mb-2 text-center" style={{ fontFamily: "'Orbitron', sans-serif" }}>
              Reset Password
            </h2>
            <p className="text-gray-400 text-center mb-6">
              Enter your email and we'll send you a reset link
            </p>

            {error && (
              <div className="bg-red-500/20 text-red-400 p-3 rounded-lg mb-4 text-center border border-red-500/30">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-gray-400 mb-2 text-sm">Email Address</label>
                <input
                  type="email"
                  className="w-full bg-gray-900/50 border border-white/20 rounded-lg p-3 focus:ring-2 focus:ring-cyan-500 focus:border-transparent outline-none transition"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="you@example.com"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="btn-primary w-full py-3 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>

            <div className="mt-6 text-center">
              <Link to="/login" className="text-cyan-400 hover:text-cyan-300 transition text-sm">
                Back to login
              </Link>
            </div>
          </>
        ) : (
          <div className="text-center">
            <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold mb-2">Check Your Email</h2>
            <p className="text-gray-400 mb-6">
              If an account exists for <strong className="text-white">{email}</strong>, we've sent a password reset link.
            </p>
            <p className="text-gray-500 text-sm mb-6">
              The link will expire in 1 hour. If you don't receive it, check your spam folder.
            </p>
            <Link to="/login" className="text-cyan-400 hover:text-cyan-300 transition">
              Return to login
            </Link>
          </div>
        )}
      </div>
      </div>
      <Footer />
    </div>
  )
}
